exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbrand-supersafra[data-v-28434fab],.navbrand-supersafra[data-v-28434fab]:focus,.navbrand-supersafra[data-v-28434fab]:hover{text-decoration:none!important;font-family:Libre Baskerville,serif;color:#3e4095;text-shadow:#fff 1px 1px 1px;letter-spacing:-4px;vertical-align:text-middle;font-size:20px}.icone-navbrand-supersafra[data-v-28434fab]{width:27.5px}", ""]);

// exports
